import { render, staticRenderFns } from "./expandable-content.vue?vue&type=template&id=3d2a56bf&scoped=true"
import script from "./expandable-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./expandable-content.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./expandable-content.vue?vue&type=style&index=0&id=3d2a56bf&prod&lang=postcss&media=print&scoped=true"
import style1 from "./expandable-content.vue?vue&type=style&index=1&id=3d2a56bf&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a56bf",
  null
  
)

export default component.exports